import { Box, Grid, Typography } from '@mui/material';
import moment from 'moment';

const labelFontSx = { fontSize: { xs: '12px', xl: '12px', lg: '11px', md: '10px' } };
const valueFontSx = { fontSize: { xs: '12px', xl: '12px', lg: '11px', md: '10px' } };

const Pill = ({ children }) => (
    <Typography sx={{
        ...valueFontSx,
        border:"1px solid #919191",
        textAlign: 'center',
        borderRadius: 2,
        // px: 1,
        // py: 0.25,
        p:0.5,
        display: 'inline-block',
        whiteSpace: 'nowrap',
        maxWidth:'160px',
        overflow: 'hidden', 
        textOverflow: 'ellipsis' 
    }}>
        {children}
    </Typography>
);

const Row = ({ label, children, labelSize = { xs: 5, md: 2 }, valueSize = { xs: 7, md: 10 } }) => (
    <Grid size={{ xs: 12, md: 12 }} sx={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', gap: 1 }} mt={1.5}>
        <Grid size={labelSize}>
            <Typography textAlign="left" sx={labelFontSx}>{label}</Typography>
        </Grid>
        <Grid size={valueSize} sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, justifyContent: 'flex-start' }}>
            {children}
        </Grid>
    </Grid>
);

const InfoList = ({ label, items = [], labelSize, valueSize }) => (
    <Row label={label} labelSize={labelSize} valueSize={valueSize}>
        {items?.length > 0 ? (
            items.map((item, idx) => <Pill key={idx}>{item.label}</Pill>)
        ) : (
            <Typography sx={valueFontSx}>--</Typography>
        )}
    </Row>
);

const ObstetricHistoryCard = ({ savedPastHistory, index, label }) => {
    const history = savedPastHistory?.obstetricHistories?.[index];

    return (
        <Grid container sx={{ backgroundColor: 'rgba(255, 255, 255, 0.3)', boxShadow: '0px 4px 4px rgba(0,0,0,0.1)', p: 1, mt: 1, borderRadius: 5 }}>

            <Grid size={{ xs: 8, md: 10 }} mt={1}>
                <Typography textAlign="left" sx={{ fontSize: { xs: '15px', xl: '17px', lg: '16px', md: '13px' } }}>{label}</Typography>
            </Grid>
            <Grid size={{ xs: 4, md: 2 }} mt={1}>
                <Typography textAlign="right" sx={{ fontSize: { xs: '14px', xl: '18px', lg: '16px', md: '13px' } }}>
                    {history?.date ? moment(history.date).format('MMM YYYY') : ''}
                </Typography>
            </Grid>

            {/* Delivery Type (parent + child pill) */}
            {history?.type?.label && (
                <Row label="Delivery Type">
                    <Pill>{history?.type?.label}</Pill>
                    {history?.type?.children?.[0]?.children?.[0]?.label && (
                        <Pill>{history?.type?.children?.[0]?.children?.[0]?.label}</Pill>
                    )}
                </Row>
            )}

            {/* Indications */}
            {history?.csIndications && <InfoList label="Indications" items={history?.csIndications} />}

            {/* Child */}
            {(history?.genderOfChild || history?.healthOfChild) && (
                <Row label="Child">
                    {history?.genderOfChild && <Pill>{history.genderOfChild}</Pill>}
                </Row>
            )}

            {/* Child weight */}
            {history?.birthWeightKg != null && (
                <Row label="Birth Weight">
                    <Pill>
                        {history.birthWeightGm != null
                            ? `${(
                                Number(history.birthWeightKg) +
                                Number(history.birthWeightGm) / 1000
                            ).toFixed(1)} kg`
                            : `${history.birthWeightKg} kg`}
                    </Pill>
                </Row>
            )}

            {/* Neonatal Outcome */}
            {history?.neonatalOutcome && (
                <Row label="Neonatal Outcome" labelSize={{ xs: 5, md: 2 }} valueSize={{ xs: 7, md: 9 }}>
                    <Pill>{history?.neonatalOutcome?.label || '--'}</Pill>
                    {history?.neonatalOutcome?.children?.[0]?.label && (
                        <Pill>{history?.neonatalOutcome?.children?.[0]?.label}</Pill>
                    )}
                </Row>
            )}

            {/* Operative Procedure */}
            {history?.operativeProcedure && <InfoList label="Operative Procedure" items={history?.operativeProcedure} labelSize={{ xs: 5, md: 2 }} valueSize={{ xs: 7, md: 9 }} />}

            {/* Complication + Blood Transfusion — pair them on a single row */}

            <Row label="Complication in procedure">
                <Pill>
                    {history?.hasComplicationProcedure ? 'Yes' : 'No'}
                </Pill>
            </Row>
            <Row label="Blood Transfusion">
                <Pill>
                    {history?.hasBloodTransfusion ? 'Yes' : 'No'}
                </Pill>
            </Row>

            {/* Anesthesia */}
            {history?.anesthesiaTypes && <InfoList label="Given Anesthesia" items={history?.anesthesiaTypes} labelSize={{ xs: 5, md: 2 }} valueSize={{ xs: 7, md: 9 }} />}

            {/* Intra & Postpartum Complication */}
            {history?.ancComplications && <InfoList label="Intra & Postpartum complication" items={history?.ancComplications} labelSize={{ xs: 5, md: 2 }} valueSize={{ xs: 7, md: 8 }} />}

            {/* During & After Delivery Complications */}
            {history?.duringAfterDeliveryComplications && <InfoList label="During & After Delivery Complications" items={history?.duringAfterDeliveryComplications} labelSize={{ xs: 5, md: 2 }} valueSize={{ xs: 7, md: 8 }} />}
        </Grid>
    );
};

export default ObstetricHistoryCard;
